import React from "react";
import styled from "styled-components";
import media from "Styles/media";
import LocalLogoImage from "Assets/Logo/logo.svg";

const LogoWrapper = styled.div`
	${(props) => props.theme.layout.center_flex};
	width: ${(props) => `${props.theme.size.logo.pc}px`};

	@media ${media.tablet} {
		width: ${(props) => `${props.theme.size.logo.tablet}px`};
	}
`;
const LogoImage = styled.img`
	width: 100%;
`;

const Logo: React.FC<{ className?: string }> = ({ className }) => {
	return (
		<LogoWrapper className={className}>
			<LogoImage src={LocalLogoImage} />
		</LogoWrapper>
	);
};

export default Logo;
